import React from 'react';
import PropTypes from 'prop-types';
import Draggable from './Draggable';
import TwoPointResizable from './TwoPointResizable';
import Authenticator from '../../protocol/Authenticator';

import './Line.css';

const getRect = (props) => {
  const { x1, y1, x2, y2 } = props.data;

  return {
    x: Math.min(x1, x2) - 5,
    y: Math.min(y1, y2) - 5,
    width: Math.abs(x2 - x1) + 10,
    height: Math.abs(y2 - y1) + 10
  };
};

const getShape = (props, rect) => {
  const { x1, y1, x2, y2 } = props.data;
  const { x, y, width, height } = rect;

  if ((x1 < x2 && y1 < y2) || (x1 > x2 && y1 > y2)) {
    return {
      x1: x + 5,
      y1: y + 5,
      x2: x + width - 5,
      y2: y + height - 5
    };
  }

  return {
    x1: x + width - 5,
    y1: y + 5,
    x2: x + 5,
    y2: y + height - 5
  };
};

const getPoints = (props) => {
  const { x1, y1, x2, y2 } = props.data;
  return { x1, y1, x2, y2 };
};

@Draggable(getRect, getShape)
@TwoPointResizable(getPoints)
export default class Line extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    isActive: PropTypes.bool,
    setActiveShapeId: PropTypes.func,
    renderDragNode: PropTypes.func,
    renderResizeNodes: PropTypes.func
  };

  render() {
    const { data, isActive, renderDragNode, renderResizeNodes } = this.props;

    let additionalProps = {
      name: 'Line',
      transform: isActive ? '' : data.transform
    };

    if (Authenticator.AUTH_DATA.isMe(data.creator)) {
      additionalProps.className = 'selectable';
      additionalProps.onClick = this.onClick;
    }

    const node = renderLine(data, additionalProps);

    if (!isActive) {
      return node;
    }

    return renderResizeNodes(renderDragNode(node));
  }

  onClick = () => {
    const { data, isActive, setActiveShapeId } = this.props;
    if (!isActive && Authenticator.AUTH_DATA.isMe(data.creator)) {
      setActiveShapeId(data.id);
    }
  };
}

export function renderLine(data, additionalProps = {}) {
  const { x1, y1, x2, y2, strokeWidth, stroke, fill } = data;

  const props = {
    x1,
    y1,
    x2,
    y2,
    strokeWidth,
    stroke,
    fill,
    ...additionalProps
  };

  return <line {...props} />;
}
